var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "community-home-popup-form" },
    [
      _c(
        "el-card",
        { staticClass: "setting-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.isEdit ? "编辑社区首页弹窗" : "添加社区首页弹窗")
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c(
                "el-form",
                {
                  ref: "communityHomeForm",
                  staticClass: "popup-form",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-layout" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "标题", prop: "title" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { placeholder: "请输入", clearable: "" },
                            model: {
                              value: _vm.formData.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "title", $$v)
                              },
                              expression: "formData.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分组类型", prop: "cdpGrpType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleCdpGrpTypeChange },
                              model: {
                                value: _vm.formData.cdpGrpType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "cdpGrpType", $$v)
                                },
                                expression: "formData.cdpGrpType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不匹配"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("CDP分组"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("消费行为"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.cdpGrpType !== 0
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "分组选择", prop: "cdpGrpId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "inline-select",
                                  attrs: {
                                    placeholder: "请选择分组",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "remote-method": _vm.queryCdpGroupList,
                                    loading: _vm.cdpGroupLoading,
                                  },
                                  model: {
                                    value: _vm.formData.cdpGrpId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "cdpGrpId", $$v)
                                    },
                                    expression: "formData.cdpGrpId",
                                  },
                                },
                                _vm._l(_vm.cdpGroupOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员级别", prop: "vipGrade" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.formData.vipGrade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "vipGrade", $$v)
                                },
                                expression: "formData.vipGrade",
                              },
                            },
                            _vm._l(_vm.vipGrades, function (grade) {
                              return _c(
                                "el-checkbox",
                                { key: grade.id, attrs: { label: grade.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(grade.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "添加企微", prop: "isAddQy" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isAddQy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isAddQy", $$v)
                                },
                                expression: "formData.isAddQy",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员标签", prop: "vipLabel" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "请选择会员标签",
                              },
                              model: {
                                value: _vm.formData.vipLabel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "vipLabel", $$v)
                                },
                                expression: "formData.vipLabel",
                              },
                            },
                            _vm._l(_vm.vipLabels, function (label) {
                              return _c("el-option", {
                                key: label.id,
                                attrs: { label: label.name, value: label.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "推荐类型", prop: "recommendType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeRecommendInfo },
                              model: {
                                value: _vm.formData.recommendType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "recommendType", $$v)
                                },
                                expression: "formData.recommendType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("无"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("领券活动"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("系统页面"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "推荐内容" } }, [
                        _vm.formData.recommendType != 1
                          ? _c(
                              "div",
                              { staticClass: "inline-items" },
                              [
                                _vm.formData.recommendType == 3
                                  ? _c(
                                      "el-select",
                                      {
                                        staticClass: "inline-select",
                                        attrs: {
                                          placeholder: "请选择页面",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.recommendContentId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "recommendContentId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.recommendContentId",
                                        },
                                      },
                                      _vm._l(_vm.pageList, function (opt) {
                                        return _c("el-option", {
                                          key: opt.id,
                                          attrs: {
                                            label: opt.label,
                                            value: opt.id,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _c("el-input", {
                                      staticClass: "inline-input",
                                      attrs: {
                                        placeholder: "请输入",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.formData.recommendContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContent",
                                            $$v
                                          )
                                        },
                                        expression: "formData.recommendContent",
                                      },
                                    }),
                                _vm._v(" "),
                                _vm.formData.recommendType == 3
                                  ? _c("el-input", {
                                      staticClass: "inline-input",
                                      attrs: {
                                        placeholder:
                                          "请输入参数，如：id=122&name=test",
                                        clearable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.formData.recommendContentParam,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContentParam",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.recommendContentParam",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "recommend-type-hint" },
                                  [
                                    _vm.formData.recommendType == 2
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [
                                            _vm._v(
                                              "请填写优惠券发放活动ID（活动类型需为领取，只填写id）"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.formData.recommendType == 3
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [
                                            _vm._v(
                                              "请选择跳转页面及输入参数，参数格式如：id=122&name=test"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户类型", prop: "userType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.userType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "userType", $$v)
                                },
                                expression: "formData.userType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("普通"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("新用户"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("老用户"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "弹窗展示时间", prop: "dateRange" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.formData.dateRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "dateRange", $$v)
                              },
                              expression: "formData.dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "展示图片", prop: "showImage" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-picture-wall",
                              attrs: {
                                action: "",
                                "list-type": "picture-card",
                                "file-list": _vm.fileList,
                                "on-change": _vm.handleImageChange,
                                "on-remove": _vm.handleImageRemove,
                                "before-upload": _vm.beforeImageUpload,
                                limit: 1,
                                "on-exceed": _vm.handleExceed,
                                accept: "image/*",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function (ref) {
                                    var file = ref.file
                                    return _c("div", {}, [
                                      _c("img", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: {
                                          src: _vm.imagePrefix + file.url,
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleImagePreview(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleImageRemove(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ]),
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "default" },
                                slot: "default",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dialog",
                            {
                              attrs: {
                                visible: _vm.previewVisible,
                                size: "tiny",
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.previewVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.imagePrefix + _vm.previewImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否启用", prop: "isEnable" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isEnable,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isEnable", $$v)
                                },
                                expression: "formData.isEnable",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否展示", prop: "isShow" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isShow,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isShow", $$v)
                                },
                                expression: "formData.isShow",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "action-buttons" },
                    [
                      _c("el-button", { on: { click: _vm.handleCancel } }, [
                        _vm._v("\n            取消\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n            保存\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }